import { theme } from '@styles/theme';
import styled, { keyframes } from 'styled-components';

export const Spinner = () => {
  return <Wrapper data-testid='spinner' />;
};

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  border: 2px solid ${theme.palette.dusty};
  border-top: 2px solid ${theme.palette.purpleEight};
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: ${spin} 2s linear infinite;
  display: inline-block;
`;
